export default __webpack_public_path__ + "static/media/icon_status_active.0c034c8b.svg";